export var LpEmailTemplate;
(function (LpEmailTemplate) {
    LpEmailTemplate["OnboardingTasksEmail"] = "OnboardingTasksEmail";
    LpEmailTemplate["PostSubscriptionInvitation"] = "PostSubscriptionInvitation";
    LpEmailTemplate["OnboardingSubscriptionSuccessfullyCompletedEmail"] = "OnboardingSubscriptionSuccessfullyCompletedEmail";
})(LpEmailTemplate || (LpEmailTemplate = {}));
//# sourceMappingURL=index.js.map